import React from 'react'
import { Box, Typography, Pill, Divider } from 'components'
import { List, ListItem, ListItemText, Link } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  sectionContainer: {
    backgroundColor: 'white',
    border: '1px solid #DDD',
    borderRadius: 10,
    marginBottom: theme.spacing(3)
  }
}))

export default function FreelancerCreditSection({ freelancer, onEdit }) {
  const classes = useStyles()
  
  // Don't render anything if there are no credits and no edit capability
  if (!onEdit && (!freelancer.credits || freelancer.credits.length === 0)) {
    return null;
  }
  
  return (
    <Box className={classes.sectionContainer}>
      <Box flex={1} pt={3.5} px={3.5} pb={2}>
        <Box flex={1} flexVariant="row space-between" mb={2.5}>
          <Typography variant="h4" style={{ fontWeight: '600' }}>
            Credits
          </Typography>

          {onEdit && (
            <Pill size="small" onClick={onEdit}>
              {(freelancer.credits || []).length > 0 ? 'Edit Credits' : 'Add Credits'}
            </Pill>
          )}
        </Box>
        
        {(freelancer.credits || []).length > 0 ? (
          <>
            <List>
              {freelancer.credits.map(({ projectName, role, projectUrl, year }, index) => {
                // Only process the URL if it exists
                let formattedUrl = null;
                if (projectUrl && projectUrl.trim() !== '') {
                  formattedUrl = projectUrl;
                  if (!formattedUrl.startsWith('https://') && !formattedUrl.startsWith('http://')) {
                    formattedUrl = `https://${formattedUrl}`;
                  }
                }
                
                return (
                  <ListItem key={index}>
                    <ListItemText
                      primary={formattedUrl ? (
                        <Link href={formattedUrl} target="_blank" rel="noopener noreferrer">{projectName}</Link>
                      ) : (
                        // Non-interactive plain text for credits without URLs
                        <Typography component="span">{projectName}</Typography>
                      )}
                      secondary={`${role} - ${year}`}
                    />
                  </ListItem>
                )
              })}
            </List>
            <Divider />
          </>
        ) : onEdit && (
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
            No credits added yet. Click "Add Credits" to showcase your work history.
          </Typography>
        )}
      </Box>
    </Box>
  )
}
